
import success from '../assets/successTotal.png';
import pingError from '../assets/icon_click_red.png';
import warning from '../assets/icon_warning.png';
import error from '../assets/failedTotal.png';


import  '../assets/css/tab_home.css';


/**
 * @param text 
 * @param icon 
 * @param time 
 */
 
const Toast = (text, icon, time = 3) => {
 
    let toastTimeout; // 用于存储定时器的引用
    // 销毁定时器
    if (toastTimeout) {
        clearTimeout(toastTimeout);
    }
 
    // 检查是否存在现有的提示框，如果存在则移除
    const successToast = document.querySelector('.success_toast');
    if (successToast) {
        successToast.remove();
    }
 
    // 创建容器
    const  div = document.createElement('div')
    div.className = "success_toast"
    // 创建二级容器
    const toastContainer = document.createElement('div')
    toastContainer.className = "success_toast_container"

    const leftToastContainer = document.createElement('div')

    toastContainer.appendChild(leftToastContainer)

    // 创建img
    if (icon) {
            
        if (icon == 'success') {
            icon = success;
            leftToastContainer.className = "success_toast_left_container"
        } else if (icon == 'pingError') {
            icon = pingError;
            leftToastContainer.className = "error_toast_left_container"
        }else if (icon == 'warning') {
            icon = warning;
            leftToastContainer.className = "error_toast_left_container"
        }else if (icon == 'error') {
            icon = error;
            leftToastContainer.className = "error_toast_left_container"
        }
        const img = document.createElement('img')
        img.src = icon
        img.className = 'success_toast_icon'
        toastContainer.appendChild(img)
    }
    //创建文本span
    const span = document.createElement('div')
    span.className = 'success_toast_text'
    span.innerHTML = text 
    toastContainer.appendChild(span)
    div.appendChild(toastContainer)
 
    document.body.appendChild(div)
    toastTimeout = setTimeout(() => {
        div.remove()
    }, time * 1000)
}
 
export default Toast